import * as React from 'react';

import { useMapContext } from '../../../context';
import { ZoomOutButton } from './ZoomOutButton';

export const ZoomOutButtonContainer: React.FC = props => {
  const { map } = useMapContext();

  return <ZoomOutButton {...props} map={map} />;
};
